<script>
  import * as BusinessDAL from "../dal/business-dal";
  import * as BusinessBL from "../bl/business-bl";
  import {
    business,
    cart,
    isAdmin,
    showSplash,
    pageClicked,
    showSectionsSlider,
    scrollY,
    isWebOnMobile,
    OS,
    forwardToApp,
  } from "../stores.js";
  import { push, location, querystring, replace, pop } from "svelte-spa-router";
  import { isRtl, formatHours } from "../utils.js";
  import CartIcon from "./CartIcon.svelte";
  import MenuItem from "./MenuItem.svelte";
  import FaRegBell from "svelte-icons/fa/FaRegBell.svelte";
  import NoSleep from "nosleep.js";
  import SectionsSlider from "./SectionsSlider.svelte";
  import { onMount, tick, createEventDispatcher } from "svelte";
  import * as InitService from "../bl/init-service";
  import InstallPopup from "./InstallPopup.svelte";

  const dispatch = createEventDispatcher();

  let noSleep = new NoSleep();

  let showInstall = false;
  let promptInstall = false;

  //determine if install prompt should be shown
  if ($isWebOnMobile && $forwardToApp.includes($OS)) {
    if (localStorage.hasOwnProperty("promptInstall")) {
      let lastPrompt = +localStorage.getItem("promptInstall");
      promptInstall = Date.now() - lastPrompt > 36 * 60 * 60 * 1000;
    } else {
      promptInstall = true;
    }
  }

  export let params = {};
  let state = "Loading";
  let isOpen = false;
  let openFrom;
  let openTo;
  let openToday;
  let dir;
  let lastCode;
  let menuSections;
  let screenHeight;
  let sectionsHeights;
  let menuSpaceFiller;

  function outerHeight(element) {
    const height = element.offsetHeight;
    const style = window.getComputedStyle(element);

    let marginTop = parseInt(style.marginTop);
    let marginBottom = parseInt(style.marginBottom);
    return height + marginTop + marginBottom;
  }

  async function calcMenuHeight() {
    let fillerHeight = sectionsHeights.reduce((acc, height) => {
      return acc + height;
    }, 0);
    if (menuSpaceFiller) menuSpaceFiller.style.height = fillerHeight + "px";
  }

  function calcSectionHeight(idx) {
    setTimeout(() => {
      sectionsHeights[idx] = outerHeight(menuSections[idx]);
      calcMenuHeight();
    }, 600);
  }

  async function getMenuSections() {
    await tick();
    menuSections = document.getElementsByClassName("menuSection");
    sectionsHeights = [];
    Array.from(menuSections).forEach((section) => {
      sectionsHeights.push(outerHeight(section));
    });
    calcMenuHeight();
  }

  $: {
    if ($business) {
      dir = isRtl($business.title) ? "rtl" : "ltr";
      getMenuSections();
      screenHeight = window.innerHeight;
    }
  }

  $: {
    if (!$business || $business.code != params.code) {
      InitService.onInitComplete(() => {
        loadBusiness(params.code);
      });
    }
  }

  $: itemsCount = Object.keys($cart.items).reduce((acc, item) => {
    if (!$cart.items[item].count) return acc;
    return acc + $cart.items[item].count;
  }, 0);

  async function loadBusiness(code) {
    if (lastCode != code) {
      $business = null;
      state = "Loading";
      $showSplash = true;
      lastCode = code;
      try {
        await BusinessBL.getBusiness(code);
        $showSplash = false;
      } catch (err) {
        console.log(err);
        state = "לא נמצא :(";
        $showSplash = false;
      }
    }
  }

  $: {
    if ($business?.schedule) {
      let date = new Date();
      let currentHour = date.getHours();
      let currentDay = date.getDay();

      openFrom = $business.schedule[currentDay].from;
      openTo = $business.schedule[currentDay].to;
      openToday = $business.schedule[currentDay].open;

      if (openToday) {
        if (openFrom < openTo) {
          isOpen = currentHour >= openFrom && currentHour < openTo;
        } else {
          isOpen = currentHour >= openFrom || currentHour < openTo;
        }

        isOpen = isOpen && $business.open;
      }
    }
  }

  async function renderList() {
    if (menuSections) {
      for (let i = 0; i < menuSections.length - 1; i++) {
        let rect = menuSections[i].getClientRects()[0];

        if (!rect) {
          menuSections[i + 1].style.display = "none";
          continue;
        }

        if (rect.bottom > screenHeight) {
          menuSections[i + 1].style.display = "none";
        } else {
          menuSections[i + 1].style.display = "block";
        }
      }
    }
  }

  function beforeScroll(sectionIdx) {
    //this function runs when user clicks the section slider
    //we need to make sure all the needed sections are visible before autoscrolling
    for (let i = 0; i <= sectionIdx; i++) {
      menuSections[i].style.display = "block";
    }
  }

  scrollY.subscribe((y) => {
    renderList();

    //we need user interaction with the page for the push to work properly
    if (y != 0 && promptInstall) {
      promptInstall = false;
      setTimeout(() => {
        push($location + $querystring + "?showInstall=true");
      }, 3000);
    }
  });

  querystring.subscribe((qs) => {
    showInstall = qs.search("showInstall=true") != -1;
  });

  onMount(async () => {
    $showSectionsSlider = true;
  });

  business.subscribe((b) => {
    if (b && $querystring.search("showInstall=true") != -1) {
      replace("/");
      push("/b/" + $business.code);
    }
  });

  //check if section has at least 1 visible item
  function shouldShowSection({ items }) {
    debugger;
    return items.some((item) => {
      debugger;
      return !item.hasOwnProperty("hidden") || !item.hidden;
    });
  }

</script>

<main>
  {#if !$business}
    <h1>{state}</h1>
  {:else}
    <SectionsSlider
      on:sectionClicked={async (e) => {
        let { title, idx } = e.detail;
        beforeScroll(idx);
        await tick();
        dispatch('routeEvent', title);
      }}
    />
    <div class="container" style={'direction:' + dir}>
      <div
        class="cover"
        style={`background-image: url(${BusinessDAL.getCoverImgUrl($business.code)})`}
      >
        <div class="info">
          <h1 class="title">
            {$business.title}
            {#if isOpen}
              <span class="open">פתוח</span>
            {:else}<span class="closed">סגור</span>{/if}
          </h1>
          <h1 class="address">{$business.address}</h1>
          <h1 class="hours">
            {openToday ? formatHours(openFrom, openTo) : ''}
          </h1>
        </div>
        <div class="allergiesMsg">
          <div class="msgWarningIcon">
            <FaRegBell />
          </div>
          {#if $business?.phone}
            <p class="rtl">
              לקוחות יקרים שימו לב! במקרה של אלרגיה או רגישות, יש ליצור קשר
              במספר:
              <a href="tel:{$business.phone}">{$business.phone} </a>
              על מנת שנוכל לעזור לכם ולהתאים את המנה הטובה ביותר עבורכם.
            </p>
          {/if}
        </div>
      </div>
      <div class="menu" class:disabled={!isOpen}>
        <div class="menuSpaceFiller" bind:this={menuSpaceFiller} />
        {#each $business.menu as section, sectionIdx (section.id)}
          {#if shouldShowSection(section)}
            <div
              class="menuSection"
              id={section.title}
              on:click={() => {
                calcSectionHeight(sectionIdx);
              }}
            >
              <div class="sectionTitle">{section.title}</div>
              {#each section.items as item (item.id)}
                {#if !item.hasOwnProperty('hidden') || !item.hidden}
                  <MenuItem {section} {item} />
                {/if}
              {/each}
            </div>
          {/if}
        {/each}
      </div>
    </div>
  {/if}

  {#if itemsCount && $cart.details.code == params.code}
    <button
      class="order"
      style={$isWebOnMobile && $forwardToApp.includes($OS) ? 'bottom: 50px' : 'bottom: 0'}
      on:click={() => {
        push('/cart/');
      }}
    >
      <CartIcon />
    </button>
  {/if}

  {#if $isAdmin}
    <div
      class="adminAccess "
      on:click={() => {
        if (!window.cordova) noSleep.enable();

        $pageClicked = true;
        push(`/admin/${params.code}`);
      }}
    >
      Admins
    </div>
  {/if}

  {#if showInstall}
    <InstallPopup
      on:close={() => {
        localStorage.setItem('promptInstall', Date.now());
        pop();
      }}
    />
  {/if}
</main>

<style>
  .rtl {
    direction: rtl;
  }

  .menuSpaceFiller {
    position: absolute;
    width: 100%;
    z-index: -1;
  }

  .allergiesMsg {
    font-size: 14px;
    padding: 15px;
    text-align: center;
    background: #ffffff;
    box-shadow: 0 10px 20px -10px;
    margin: 10px 40px 20px 40px;
    border-radius: 15px;
    display: flex;
    align-items: center;
  }

  .allergiesMsg > p {
    margin: 0;
  }
  .allergiesMsg > p > a {
    font-size: 15px;
    color: #1db6ce;
  }
  .msgWarningIcon {
    width: 25px;
    min-width: 25px;
    display: inline-block;
    color: var(--red1);
    margin-left: 5px;
  }
  main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - var(--nav-bar-height));
  }

  .container {
    width: 100%;
    max-width: 560px;
    margin-bottom: 80px;
    height: fit-content;
    margin-top: 100px;
  }

  .cover {
    width: 100%;
    min-height: 300px;
    direction: inherit;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    border-radius: 3px;
  }

  h1 {
    margin: 0;
    padding: 0;
  }

  .info {
    width: 100%;
    background: #000000a8;
    color: white;
    font-family: "Rubik";
    font-size: 1.5rem;
    padding: 15px;
    box-sizing: border-box;
    margin-top: 110px;
  }

  .title {
    margin-bottom: 16px;
    font-size: 3rem;
  }

  .hours,
  .address {
    font-size: 2rem;
    font-weight: 500;
  }

  .address {
    margin-top: 5px;
  }

  .adminAccess {
    position: fixed;
    left: 0;
    bottom: 50px;
    font-family: "Rubik";
    font-size: 20px;
    padding: 10px;
    color: white;
    border: 3px solid var(--blue1);
    border-left: none;
    cursor: pointer;
    border-radius: 0px 10px 10px 0px;
    box-shadow: 0px 3px 10px -6px black;
    background: var(--grey1);
    z-index: 9;
  }

  .order {
    width: 85px;
    height: 85px;
    border: none;
    color: #fff;
    background-color: var(--blue1);
    outline: none;
    border-radius: 100px;
    margin: 2px;
    font-size: 16px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 50px;
    box-shadow: 0px 10px 15px -10px black;
    z-index: 1;
  }

  .open {
    color: var(--green1);
    border: 3px solid;
    padding: 1px 10px 3px 10px;
    border-radius: 100px;
    font-size: 24px;
  }

  .closed {
    color: var(--red1);
    border: 3px solid;
    padding: 1px 10px 3px 10px;
    border-radius: 100px;
    font-size: 24px;
  }

  .disabled {
    /* filter: saturate(0) blur(1.5px); */
    filter: saturate(0) contrast(0.5) brightness(1.4);
    pointer-events: none;
  }

  .menuSection {
    margin-bottom: 40px;
    box-shadow: 0 5px 6px #001a2926;
    background: white;
    will-change: height;
    border-radius: 4px;
    /* overflow: hidden; */
  }

  .sectionTitle {
    background: var(--blue1);
    color: white;
    font-size: 28px;
    font-family: "Rubik";
    padding: 15px;
    font-weight: 600;
  }

  @media only screen and (max-width: 560px) {
    main {
      justify-content: flex-start;
    }

    .container {
      margin-top: 0;
    }
  }
  @media only screen and (max-width: 490px) {
    .allergiesMsg {
      margin: 0;
      border-radius: 0;
    }

    .container {
      margin-top: 0;
    }
  }

</style>
